import { useEffect } from 'react';
import type { RefObject } from 'react';

/**
 * Keeps the keyboard-active option scrolled into view within a dropdown list.
 * Shared by MenuButton / ListboxSelect / Combobox and the Landing search fields.
 */
export function useScrollActiveIntoView(
    activeIndex: number,
    listRef: RefObject<HTMLElement | null>,
): void {
    useEffect(() => {
        if (activeIndex >= 0 && listRef.current) {
            const el = listRef.current.children[activeIndex] as HTMLElement | undefined;
            if (el) el.scrollIntoView({ block: 'nearest' });
        }
    }, [activeIndex, listRef]);
}
